import api from './api';

const BASE = '/design-systems';

const designSystemService = {
  createDesignSystem: async (data) => {
    const response = await api.post(`${BASE}`, data);
    return response.data.data;
  },

  listDesignSystems: async () => {
    const response = await api.get(`${BASE}`);
    return response.data.data;
  },

  getDesignSystem: async (id) => {
    const response = await api.get(`${BASE}/${id}`);
    return response.data.data;
  },

  updateDesignSystem: async (id, data) => {
    const response = await api.put(`${BASE}/${id}`, data);
    return response.data.data;
  },

  deleteDesignSystem: async (id) => {
    const response = await api.delete(`${BASE}/${id}`);
    return response.data;
  },

  uploadAsset: async (designSystemId, file, assetType = 'image') => {
    const form = new FormData();
    form.append('file', file);
    form.append('assetType', assetType);
    const response = await api.post(`${BASE}/${designSystemId}/assets`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data.data;
  },

  deleteAsset: async (designSystemId, assetName) => {
    const response = await api.delete(`${BASE}/${designSystemId}/assets/${assetName}`);
    return response.data;
  },
};

export default designSystemService;
